var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.DocumentName)?[(_vm.row.DocumentName)?_c('FormButton',{attrs:{"size":"small","type":"text","onclick":"window.open(this.href,'_blank');return false;","href":_vm.row.DocumentName,"tag":"a","left-icon":"md-eye"}},[_vm._v("View")]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }